import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

import * as styles from './GatedForm.module.scss';

const FormImage = ({ heroImage, imgTitle }) => {
  if (!heroImage) {
    return null;
  }
  const imageData = heroImage?.gatsbyImageData;
  const img = heroImage?.file?.url;

  if (imageData) {
    return (
      <div className={styles.imgContainer}>
        <GatsbyImage
          image={heroImage.gatsbyImageData}
          className={styles.heroImage}
          imgStyle={{ objectFit: 'contain' }}
          alt={imgTitle}
        />
      </div>
    );
  } else if (img) {
    return (
      <div className={styles.imgContainer}>
        <img src={img} className={styles.heroImage} loading="lazy" alt={imgTitle} />
      </div>
    );
  }
  return null;
};

export default FormImage;
